import { CloudOffIcon } from "lucide-react"
import type { ReactNode } from "react"
import { Button } from "@/primitives/button.tsx"
import { Callout } from "./callout.tsx"

/*
 * A section of a page that couldn't be read, in place of what it would have shown, while the rest
 * of the page stands. It reads the same wherever it appears: the network-error icon, what couldn't
 * be loaded, and Retry. A page that couldn't be read at all is a RefusalState instead.
 */

/** `children` says what couldn't be loaded, or why; `onRetry` asks again, as `query.refetch()`. */
export function SectionError({ children, onRetry }: { children: ReactNode; onRetry: () => void }) {
  return (
    <Callout
      tone="destructive"
      icon={CloudOffIcon}
      action={
        <Button variant="outline" size="sm" onClick={onRetry}>
          Retry
        </Button>
      }
    >
      {children}
    </Callout>
  )
}
